var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRentSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2577:6149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0023 26.1435C20.0177 26.1435 25.7048 20.4564 25.7048 13.441C25.7048 6.42563 20.0177 0.738525 13.0023 0.738525C5.98691 0.738525 0.299805 6.42563 0.299805 13.441C0.299805 20.4564 5.98691 26.1435 13.0023 26.1435Z",
    stroke: "#2B2F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0017 23.5598C18.5902 23.5598 23.1206 19.0294 23.1206 13.4409C23.1206 7.8524 18.5902 3.32202 13.0017 3.32202C7.41319 3.32202 2.88281 7.8524 2.88281 13.4409C2.88281 19.0294 7.41319 23.5598 13.0017 23.5598Z",
    stroke: "#2B2F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0342 9.52759V13.5368L16.5203 17.0189",
    stroke: "#2B2F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 3.354V5.21885",
    stroke: "#2B2F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 21.6592V23.524",
    stroke: "#2B2F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0846 13.4409H21.2197",
    stroke: "#2B2F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77988 13.4409H2.91504",
    stroke: "#2B2F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2577:6149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.438965)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentSvg);
export default __webpack_public_path__ + "static/media/RentSvg.a918e09d.svg";
export { ForwardRef as ReactComponent };